import { render, staticRenderFns } from "./FUniswapPairLiquidityInfo.vue?vue&type=template&id=457f3819&"
import script from "./FUniswapPairLiquidityInfo.vue?vue&type=script&lang=js&"
export * from "./FUniswapPairLiquidityInfo.vue?vue&type=script&lang=js&"
import style0 from "./FUniswapPairLiquidityInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports